// @flow
import React from 'react';

import { ProductExclusiveCollectionSpace } from 'Components/widgets/product-exclusive-collection-space/ProductExclusiveCollectionSpace.jsx';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer.jsx';
import { addTranslationKeys } from 'Src/i18n';

type CMSProps = {
  id: string,
  mediaUrl: string,
  text: string,
  title: string,
};

type GQLProps = {
  config: CMSContent,
};

type LineProps = CMSProps & GQLProps;

export function ProductExclusiveCollectionSpaceLine({
  config,
  id,
  mediaUrl,
  text,
  title,
}: LineProps) {
  addTranslationKeys(config);
  return (
    <SiteContainer id={id} className="Line" size="medium">
      <ProductExclusiveCollectionSpace mediaUrl={mediaUrl} text={text} title={title} />
    </SiteContainer>
  );
}
